module.exports = __webpack_public_path__ + "static/media/illustrator.963886b4.png";